import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "./IconButton";
import HomeIcon from "./Icons/HomeIcon";
import PendingDocumentsIcon from "./Icons/pendingDocumentsIcon";
import DocumentsIcon from "./Icons/DocumentsIcon";
import DocumentsBigIcon from "./Icons/DocumentsBigIcon";
import CarnetIcon from "./Icons/CarnetIcon";
import PDFIcon from "./Icons/PdfBoletaIcon";
import AdressIcon from "./Icons/AdressIcon";
import BankAccountIcon from "./Icons/CuentaBancariaIcon";
import StatisticField from "../GreyRectangles/StatisticField";
import GreyCard from "../GreyRectangles/GreyCard";
import "./Resume.css";
import InfoCard from "../GreyRectangles/InfoCard";
import InfoCard3 from "../GreyRectangles/InfoCard3";
import { AlignedBoxSubTitle } from "../../../../styles/texts";
import PreInstallationCard from "./PreInstallationCard";

import PreInstallationBox from "../GreyRectangles/StateGreyBox"; /* main */

// Importamos la interfaz SpecificBooking
import { PostInstallationDocuments, SpecificBooking, UserContract } from "../../../../types/responseTypes";
import { link } from "fs";
import BaseStatisticsCard from "../GreyRectangles/BaseStatisticsCard";

type TabType = "inicio" | "documentos" | "pendientes";

interface ResumeBarSignedProps {
  specificBooking: SpecificBooking;
  userContract?: UserContract | null;
  installationDocuments?: PostInstallationDocuments | null;
}

const ResumeBarSigned: React.FC<ResumeBarSignedProps> = ({
  specificBooking, 
  userContract,
  installationDocuments,
}) => {

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>("inicio");
  const handleSetActiveTab = (tab: TabType) => { setActiveTab(tab) };
  const handleNavigateToUploadCarnet = () => { navigate("/upload-carnet") };

  // Valores hardcodeados para segundoPropietario y financiador
  const segundoPropietario = true; // Cambiar a false si se necesita
  const financiador = true; // Cambiar a false si se necesita

  const findDocumentUrl = (where: string, name: string) => {
    // si name no es encontrado, retorna undefined y el boton deja de ser clickeable
    if (where === "installationDocs") {
      return installationDocuments?.installationDocuments.find(doc => doc.name === name)?.url;
    } else if (where === "contract") {
      return userContract?.documents.find(doc => doc.name === name)?.url;
    } 
    return undefined;
  };
  
  //const linkToPropuesta = `https://ruuf.cl/proposal/booking/${userBooking.bookingId}`; // Botón revisar propuesta
  //const linkToCredit = findDocumentUrl("contract", "contrato_creditu");
  const linkToPrenda = findDocumentUrl("contract", "prenda");
  const linkToPagare = findDocumentUrl("contract", "pagare");
  const linkToMandato = findDocumentUrl("contract", "mandato");
  const linkToCompraVenta = findDocumentUrl("contract", "compraventa");
  const linkToInverter = specificBooking.inverter.datasheetUrl; 
  const linkToPaneles = specificBooking.solarPanel.datasheetUrl;
  const linkToConnectionWithEnel = findDocumentUrl("installationDocs", 'Respuesta Solicitud de Conexión');
  const linkToCertificate = findDocumentUrl("installationDocs", ''); //"Ver documento Aprobación SEC"
  
  const openLink = (link: string | undefined) => {
    if (link) {
      const formattedLink = link;//encodeURI(link);
      window.open(formattedLink, "_blank");
    }
  };


  return (
    <div>
      <div className="ResumeBar">
        <IconButton
          label="Inicio"
          icon={<HomeIcon />}
          isActive={activeTab === "inicio"}
          onClick={() => handleSetActiveTab("inicio")}
        />
        <IconButton
          label="Documentos"
          icon={<DocumentsIcon />}
          isActive={activeTab === "documentos"}
          onClick={() => handleSetActiveTab("documentos")}
        />
        <IconButton
          label="Pendientes"
          icon={<PendingDocumentsIcon />}
          isActive={activeTab === "pendientes"}
          onClick={() => handleSetActiveTab("pendientes")}
        />
      </div>

      <div>
        {activeTab === "inicio" && (
          <div className="flex flex-col items-center">
            
            <BaseStatisticsCard specificBooking={specificBooking} />

            {/*<PreInstallationCard />*/}
            
            <PreInstallationBox
              currentStage="Etapa actual"
              title="Visita pre-instalación"
              date="14 de septiembre"
              description="Estamos a la espera de la visita pre-instalación. En esta visita, el equipo técnico revisa los techos, el tablero general de la casa, el lugar donde se ubicará el inversor, la ruta de canalización, etc. Recomendamos que te encuentres en tu casa para que revises y estés de acuerdo con los detalles del sistema."
              buttonText="Ver próximos pasos"
              buttonIcon="rightarrow"
              onButtonClick={() => navigate("/steps")}
            />

          </div>
        )}

        {activeTab === "documentos" && (
          <div>
            {/* Agregar cada InfoCard según la imagen */}
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Compraventa"
              subtitle="Contrato"
              buttonText={ linkToCompraVenta ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToCompraVenta)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Mandato"
              subtitle="Contrato"
              buttonText={ linkToMandato ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToMandato)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Pagaré"
              subtitle="Contrato"
              buttonText="Ver"
              onButtonClick={() => openLink(linkToPagare)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Prenda"
              subtitle="Contrato"
              buttonText={ linkToPrenda ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToPrenda)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Aprobación SEC"
              subtitle="Certificado"
              buttonText={ linkToCertificate ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToCertificate)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Conexión con Enel"
              subtitle="Contrato"
              buttonText={ linkToConnectionWithEnel ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToConnectionWithEnel)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Paneles"
              subtitle="Ficha técnica"
              buttonText={ linkToPaneles ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToPaneles)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Inversor"
              subtitle="Ficha técnica"
              buttonText={ linkToInverter ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToInverter)}
            />
          </div>
        )}

        {activeTab === "pendientes" && (
          <div>
            <div
              style={{
                display: "flex", // Añade flexbox
                justifyContent: "center",
                marginTop: "20px",
                alignItems: "center",
                color: "#8C8F9F",
                marginLeft: "15px",
              }}
            >
              <AlignedBoxSubTitle fontSize="16px">
                Documentos necesarios para poder iniciar el proceso de
                instalación. Sin entregarnos esta información, no podemos
                coordinar tu fecha de instalación.
              </AlignedBoxSubTitle>
            </div>
            <div style={{ marginTop: "20px" }}>
              {/* Agregar cada InfoCard según la imagen */}
              <InfoCard
                logo={<CarnetIcon />}
                title="Carnet"
                subtitle=""
                buttonText="Subir"
                onButtonClick={handleNavigateToUploadCarnet}
              />
              {/* InfoCard adicional si segundoPropietario es true */}
              {segundoPropietario && (
                <InfoCard
                  logo={<CarnetIcon />}
                  title="Carnet Segundo Propietario"
                  subtitle=""
                  buttonText="Subir"
                  onButtonClick={handleNavigateToUploadCarnet}
                />
              )}

              {/* InfoCard adicional si financiador es true */}
              {financiador && (
                <InfoCard
                  logo={<BankAccountIcon />}
                  title="Cuenta bancaria del Financiador"
                  subtitle="Información de cuenta bancaria del financiador"
                  buttonText="Subir"
                  onButtonClick={() =>
                    console.log("Subir Cuenta bancaria del Financiador")
                  }
                />
              )}
              <InfoCard
                logo={<PDFIcon />}
                title="PDF Boleta"
                subtitle="{Distribuidora}"
                buttonText="Subir"
                onButtonClick={() => console.log("Subir PDF Boleta")}
              />
              <InfoCard
                logo={<AdressIcon />}
                title="Dirección para envío"
                subtitle="Hay contratos que deberás firmar en físico. Estos te los enviaremos y deberás firmarlos."
                buttonText="Subir"
                onButtonClick={() => console.log("Subir Dirección para envío")}
              />
              <InfoCard
                logo={<BankAccountIcon />}
                title="Cuenta bancaria"
                subtitle="Depósito de excedentes"
                buttonText="Subir"
                onButtonClick={() =>
                  console.log("Subir Cuenta bancaria - Depósito de excedentes")
                }
              />
              <InfoCard
                logo={<BankAccountIcon />}
                title="Cuenta bancaria"
                subtitle="Inscripción de PAC para el pago de cuotas mensuales"
                buttonText="Subir"
                onButtonClick={() =>
                  console.log("Subir Cuenta bancaria - Inscripción de PAC")
                }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResumeBarSigned;
